// React
import React, { useCallback } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// MUI
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

// Styles
import styles from './style.module.scss';

// Assets
import MascotImg from '../../../../components/assets/mascot/mascot1.png';

// Context
import { useOnboardingContext } from '../../context';

type FinishedSectionProps = {
  text: string;
  isLastSection?: boolean;
  onNextSection: () => void;
}

const FinishedSection: React.FC<FinishedSectionProps> = ({
  text,
  isLastSection = false,
  onNextSection,
}) => {
  // i18n
  const { t } = useTranslation();

  // Context
  const { onFinishOnboarding } = useOnboardingContext();

  // Methods

  // Handlers
  const handleNextSection = useCallback(() => {
    if (isLastSection) {
      onFinishOnboarding();
    } else {
      onNextSection();
    }
  }, [isLastSection, onNextSection, onFinishOnboarding]);

  return (
    <div className={styles.finishedSectionContainer}>
      <Typography variant="h5" component="p" sx={{ marginBottom: 2, textAlign: 'center' }}>
        {text}
      </Typography>

      <img src={MascotImg} alt="Finished" />

      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{ marginTop: 2 }}
        onClick={handleNextSection}
      >
        {isLastSection ? t('onboarding.common.get_started') : t('onboarding.common.next_section')}
      </Button>
    </div>
  )
}

export default FinishedSection;
